var GalleryDataTestId = /* @__PURE__ */ ((GalleryDataTestId2) => {
  GalleryDataTestId2["GALLERY_IMAGE"] = "gallery-image--gallery-component";
  return GalleryDataTestId2;
})(GalleryDataTestId || {});
export {
  GalleryDataTestId
};
